import React, { FC } from 'react'
import tw from 'tailwind-styled-components'
import { ImageProps } from 'next/image'
import { useTranslation } from 'next-i18next'
import { RepresentativeFragment } from '@foros-fe/graphql'
import { ResponsiveImage } from './ResponsiveImage'
import PhoneGreen from '@foros-fe/assets/icons/phone-green.png'
import MailGreen from '@foros-fe/assets/icons/mail-green.png'

export type Props = Omit<RepresentativeFragment, 'photoUrl'> & {
  photoUrl?: ImageProps['src'] | null
}

const Name = tw.p`font-poppins text-lg mb-2`
const Contact = tw.p`text-sm`
const ImgContainer = tw.div`flex mr-5 rounded overflow-hidden`
const Title = tw(Contact)`text-gray-700`
const RowContainer = tw.div`flex flex-row items-center mb-3 md:mb-4`
const InfoIcon = tw.div`flex items-center mr-4`

export const ContactCard: FC<Props> = ({
  firstName,
  lastName,
  email,
  phoneNumber,
  title,
  photoUrl,
}) => {
  const { t } = useTranslation('enum')

  return (
    <div className='flex-col'>
      <RowContainer>
        {photoUrl ? (
          <ImgContainer>
            <ResponsiveImage objectFit='cover' src={photoUrl} sizes={[70, 80]} unoptimized />
          </ImgContainer>
        ) : null}
        <div className='flex flex-col'>
          <Name>
            {firstName} {lastName}
          </Name>
          <Title>{t(`RepresentativeTitle.${title}`)}</Title>
        </div>
      </RowContainer>
      <RowContainer>
        <InfoIcon>
          <ResponsiveImage src={MailGreen} sizes={[20, 30]} />
        </InfoIcon>
        <Contact>{email}</Contact>
      </RowContainer>
      {phoneNumber ? (
        <RowContainer>
          <InfoIcon>
            <ResponsiveImage src={PhoneGreen} sizes={[20, 30]} />
          </InfoIcon>
          <Contact>{phoneNumber}</Contact>
        </RowContainer>
      ) : null}
    </div>
  )
}
